export default {
  store_name: 'Store Name',
  store_url: 'Store URL',
  platform: 'Platform',
  seller_id: 'Seller ID',
  owner_name: 'Owner’s Name',
  store_owner_no: 'Owner’s ID Number',
  va_account: 'VA Account',
  va_institute: 'VA Institute',
  va_status: 'VA Status',
  review_time: 'Review Time',
  close_time: 'Close Time',
  va_collection: 'VA Collection',
  va_list: 'VA List',
  bank_proof: 'Bank Proof',
  va_number: 'number of VA Accounts',
  va_transactions: 'VA Transactions',
  generating: 'Generating',
  download_excel: 'Download(Excel)',
  download_proof: 'Download(Bank Proof)',
  transaction_status: 'Transaction Status',
  create_single_va_account: 'Create Single Virtual Account',
  create_va_account: 'Create Virtual Account',
  single_create_va: 'Single Create VA',
  batch_create_va: 'Batch Create VA',
  account_details: 'Account Details',
  audit_status: 'Audit Status',
  total_number_va: 'Total number of VA Accounts',
  enter_details_create_va: 'Enter your account details to create your Virtual Account.',
  enter_details_create_a_va: ' Create one virtual account by filling up a creation form',
  enter_details_create_batch_va: 'Batch create virtual account by uploading an excel file.',
  create_batch_virtual_accounts: 'Create Batch Virtual Accounts',
  batch_virtual_accounts_details: 'Batch Virtual Account Details',
  batch_virtual_accounts_tip_1: 'Download and fill-out the template to create batch virtual accounts',
  va_template: 'VA Template',
  lastest_template_tips: 'Latest template: updated the created store list',
  batch_virtual_accounts_tip_2: 'Upload your filled template file using the latest VA template to submit batch virtual accounts',
  download_bank_proof_zip_tip: 'It will take a while to download the file, please do not switch to other pages of this system, do you want to download?'
}
